module.exports = __webpack_public_path__ + "static/media/chips-pickles.81540bc1.png";